import { Navigate, useLocation } from 'react-router-dom';

import { isUserAuthenticated } from '@/utils/store';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * 用户端路由守卫
 * - 已登录 → 显示 children
 * - 未登录 → 跳转 /login
 */
export default function AuthGuard({ children }: AuthGuardProps) {
  const location = useLocation();

  if (!isUserAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
